import request from '@/utils/request'

const baseURL = '/administrative-boundaries'

export default {
  getTypes(params = {}) {
    return request({
      url: `${baseURL}/types`,
      method: 'get',
      params,
    })
  },

  getDataTypes(params = {}) {
    return request({
      url: '/data/administrative-boundary-types',
      method: 'get',
      params,
    })
  },

  getGeoJson(params = {}) {
    return request({
      url: `${baseURL}/geojson`,
      method: 'get',
      params,
    })
  },

  upload(formData) {
    return request({
      url: `${baseURL}/upload`,
      method: 'post',
      data: formData,
    })
  },

  list(params = {}) {
    return request({
      url: baseURL,
      method: 'get',
      params,
    })
  },

  show(id) {
    return request({
      url: `${baseURL}/${id}`,
      method: 'get',
    })
  },

  nearest(data) {
    return request({
      url: `${baseURL}/nearest`,
      method: 'post',
      data,
    })
  },

  /**
   * Resolve every administrative / urban / grid layer for a project or explicit point.
   * Payload: { project_id, year } OR { latitude, longitude, year }.
   * Do not send type / types / limit.
   */
  determine(data) {
    return request({
      url: `${baseURL}/determine`,
      method: 'post',
      data,
    })
  },

  determineAdministrativeBoundary(data) {
    return this.determine(data)
  },
}
